import { type FunctionComponent } from 'preact'
import { html } from 'htm/preact'
import { Card } from '../components/card.js'
import { TOOLS } from '../data/tools.js'
import { APP_SIGNUP_URL } from '../constants.js'
import type { AppState } from '../state.js'
import './tools.css'

export const ToolsRoute:FunctionComponent<{
    state:AppState
}> = function ToolsRoute () {
    return html`<div class="route tools">
        <div class="tools-index">
            <h2>Free HVAC Tools</h2>
            <p class="tools-intro">
                Client-side tools for EPA Section 608 compliance
                and refrigerant management. No account required.
            </p>
            <div class="cards cards-grid" aria-label="Tools grid">
                ${TOOLS.map(tool => html`
                    <${Card}
                        key=${tool.id}
                        title=${tool.name}
                        description=${tool.description}
                    >
                        <a href=${tool.href} class="tool-link">
                            Open
                        </a>
                    <//>
                `)}
            </div>
            <div class="tools-funnel-cta">
                <p class="tools-funnel-cta-text">
                    Stop recalculating every visit.
                    Log it once in the app and your records
                    are always audit-ready.
                </p>
                <a
                    href=${APP_SIGNUP_URL}
                    class="btn btn-primary"
                >
                    Start free
                </a>
            </div>
        </div>
    </div>`
}
